import { render, staticRenderFns } from "./kinh-doanh-doi-item-v2.vue?vue&type=template&id=42378116&scoped=true"
import script from "./kinh-doanh-doi-item-v2.vue?vue&type=script&lang=js"
export * from "./kinh-doanh-doi-item-v2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42378116",
  null
  
)

export default component.exports